import React from 'react'
import './ourcourses.css'
import Menubar from '../home/menubar/Menubar'
import Address from '../home/footer/Address'
import ScrollToTopProgress from '../home/header/ScrollToTopProgress'
import { useNavigate } from 'react-router-dom'
import { RiFileWord2Line } from "react-icons/ri";
import { SiAdobephotoshop } from "react-icons/si";
import { FaLaptopCode } from "react-icons/fa";
import { TiHtml5 } from "react-icons/ti";
import { CgTally } from "react-icons/cg";
import { GiClapperboard } from "react-icons/gi";
import Header from '../home/header/Header'
import { training } from '../home/data.js'

function Ourcourses() {
    const {training_img_url} = training;
    const navigate = useNavigate();
  return (
    <div>
        <Header/>
        <Menubar/>
        <div className='training-img'>
            <img src={training_img_url} style={{width: '100%'}} alt="training-img" />
          </div>
        <div className='container'>
            <div className="container">
                <section className='header-title'>
                    <div>
                        <h1>Training Courses</h1>
                        <h5 style={{borderBottomStyle: 'groove', top:'10px'}}>We deliver high-value, industry-focused training that equips you for real-world IT careers.</h5>
                    </div>
                </section>
            </div>
                <div className='inner-container-top'>
                    <div className="cards">
                        <div className="front">
                            <p className='course-icons'><RiFileWord2Line/></p>
                            <p>MS OFFICE</p>
                        </div>
                        <div className="back">
                            <p><b>Course Duration:</b></p>
                            <p>2 Months</p>
                            <button className='course-btn' onClick={() => navigate("/coursedetails/ms-Office")}>More Info..</button>
                        </div>
                    </div>
                    <div className="cards">
                        <div className="front">
                            <p className='course-icons'><SiAdobephotoshop/></p>
                            <p>DTP</p>
                        </div>
                        <div className="back">
                            <p><b>Course Duration:</b></p>
                            <p>2 Months</p>
                            <button className='course-btn' onClick={() => navigate("/coursedetails/dtp")}>More Info..</button>
                        </div>
                    </div>
                    <div className="cards">
                        <div className="front">
                            <p className='course-icons'><FaLaptopCode/></p>
                            <p>C-LANGUAGE</p>
                        </div>
                        <div className="back">
                            <p><b>Course Duration:</b></p>
                            <p>2 Months</p>
                            <button className='course-btn' onClick={() => navigate("/coursedetails/c-language")}>More Info..</button>
                        </div>
                    </div>
                </div>
                <div className='inner-container-bottom'>
                    <div className="cards">
                        <div className="front editing-align">
                            <p className='course-icons'><GiClapperboard /></p>
                            <p>VIDEO EDITING</p>
                        </div>
                        <div className="back">
                            <p><b>Course Duration:</b></p>
                            <p>2 Months</p>
                            <button className='course-btn' onClick={() => navigate("/coursedetails/video-editing")}>More Info..</button>
                        </div>
                    </div>
                    <div className="cards">
                        <div className="front">
                            <p className='course-icons'><CgTally/></p>
                            <p>TALLY</p>
                        </div>
                        <div className="back">
                            <p><b>Course Duration:</b></p>
                            <p>2 Months</p>
                            <button className='course-btn' onClick={() => navigate("/coursedetails/tally")}>More Info..</button>
                        </div>
                    </div>
                    <div className="cards">
                        <div className="front html-align">
                            <p className='course-icons'><TiHtml5/></p>
                            <p>HTML</p>
                        </div>
                        <div className="back">
                            <p><b>Course Duration:</b></p>
                            <p>2 Months</p>
                            <button className='course-btn' onClick={() => navigate("/coursedetails/html")}>More Info..</button>
                        </div>
                    </div>
                </div>
        </div>
        <Address/>
        <ScrollToTopProgress/>
    </div>
  )
}

export default Ourcourses